<kt-base-modal [title]="patrolDetail?.patrol_name" [emitCloseEvent]="true" (eModalClose)="activeModal.close(hasScanned ? { reload: true } : null)">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div class="fix-height p-4">

        <div class="mb-4 d-flex flex-wrap" style="gap: 16px;">
          <div>
            <span class="text-muted fw-bold">Patrol Buffer : </span>
            <span class="fw-bolder">{{ patrolDetail?.patrol_buffer_time }} Minutes</span>
          </div>
          <div *ngIf="patrolDetail?.responsibility_type">
            <span class="text-muted fw-bold">Patrol Type : </span>
            <span class="fw-bolder">{{ responsibilityTypeLabel[patrolDetail.responsibility_type] || patrolDetail.responsibility_type }}</span>
          </div>
          <div *ngIf="patrolDetail?.patrol_assigned_role_names">
            <span class="text-muted fw-bold">Assigned Roles : </span>
            <span class="fw-bolder">{{ patrolDetail.patrol_assigned_role_names }}</span>
          </div>
        </div>
        <!-- STATUS GUIDE -->
        <div class="mb-4 patrol-accordion-popup">
          <ngb-accordion #statusAcc="ngbAccordion">
            <ngb-panel id="status-guide-panel">
              <ng-template ngbPanelTitle>
                <div class="d-flex align-items-center text-primary cursor-pointer w-100">
                  <div class="status-guide-header w-100">
                    <div class="d-flex align-items-center w-100 justify-content-between">
                      <div class="d-flex align-content-center">
                        <svg-icon class="svg_icon18x18 me-2 custom-svg-size-20" src="assets/media/iq-svg/without_circle/icon_set_3/information.svg"></svg-icon>
                        <span class="status-guide-title">Status Guide</span>
                      </div>
                      <span class="collaps-icon"></span>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <div class="mt-2">
                  <div class="status-guide-container">

                    <div class="status-guide-grid">
                      <div class="status-item">
                        <div class="status-badge on-time">On Time</div>
                        <div class="status-desc">Scanned within the allowed time window (including buffer)</div>
                      </div>
                      <div class="status-item">
                        <div class="status-badge duplicate">Duplicate</div>
                        <div class="status-desc">Slot already completed — extra scan recorded</div>
                      </div>
                      <div class="status-item">
                        <div class="status-badge early">Early</div>
                        <div class="status-desc">Scanned before the allowed time window started</div>
                      </div>
                      <div class="status-item">
                        <div class="status-badge missed">Missed</div>
                        <div class="status-desc">No valid scan was done before the time window closed</div>
                      </div>
                      <div class="status-item">
                        <div class="status-badge late">Late</div>
                        <div class="status-desc">Scanned after the allowed time window ended</div>
                      </div>
                      <div class="status-item">
                        <div class="status-badge pending">Pending</div>
                        <div class="status-desc">Waiting for scan — time window is still open</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>

        <div class="row shift-patrol-content-row">
          <div class="col-md-7 shift-patrol-timeline-col">
            <div class="shift-patrol-timeline-scroll">

              <!-- Checkpoint item template -->
              <ng-template #checkpointItem let-cp="cp" let-last="last" let-faded="faded">
                <div class="timeline-item" [class.last-item]="last" [class.faded-item]="faded">
                  <div class="timeline-icon">
                    <svg-icon class="svg_icon18x22 custom-svg-size-32" src="assets/media/iq-svg/with_circle/icon_set_1/area_patrol.svg"></svg-icon>
                  </div>
                  <div class="timeline-content ms-3">
                    <div class="d-flex align-items-center mb-1">
                      <h6 class="mb-0 me-2 custom-font-size-16">{{ cp.area_name }}</h6>
                      <span class="badge custom-badge-rounded ms-2" [style.backgroundColor]="cp.statusColor"
                        style="color: white; width: 70px; border-radius: 8px; font-size: 0.8rem;"> {{ cp.displayStatus }}
                      </span>
                      <span [ngbTooltip]="'Action By Others'" [container]="'body'"
                        *ngIf="cp.is_action_by_other" class="ms-1">
                        <svg-icon class="svg_icon13x13 d-inline warinings" placement="bottom" src="assets/media/iq-svg/without_circle/icon_set_3/update_by_other_user.svg"></svg-icon>
                      </span>
                      <span [ngbTooltip]="'Offline'" [container]="'body'"
                        *ngIf="cp.is_action_offline" class="ms-1">
                        <svg-icon class="svg_icon13x13 d-inline warinings warning-config-color" placement="bottom" src="assets/media/iq-svg/without_circle/icon_set_3/offline.svg"></svg-icon>
                      </span>
                    </div>

                    <div class="text-muted">
                      <ng-container *ngIf="patrolDetail?.patrol_mode === 'SCHEDULE'">
                        <strong>Schedule: </strong> {{ formatDateTime(cp.start_time) }} to {{ formatTimeOnly(cp.end_time) }}
                      </ng-container>
                      <ng-container *ngIf="patrolDetail?.patrol_mode === 'INTERVAL'">
                        <strong>Expected: </strong> {{ formatDateTime(cp.expected_scan_time) || 'N/A' }}
                      </ng-container>
                    </div>

                    <div *ngIf="cp.scan_time" class="text-muted">
                      <strong>Scan Time: </strong> {{ formatDateTime(cp.scan_time) }}
                      <ng-container *ngIf="(cp.is_completed_by_other || cp.is_action_by_other) && cp.completed_by_name">
                        <span class="mx-1">|</span>
                        <span class="completed-by-badge">
                          By {{ cp.completed_by_name }}
                        </span>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>

              <!-- INDIVIDUAL PATROL — flat list (no grouping) -->
              <ng-container *ngIf="!isLocationShared">
                <div class="patrol-timeline">
                  <div *ngFor="let cp of patrolDetail?.checkpoints; let last = last">
                    <ng-container *ngTemplateOutlet="checkpointItem; context: { cp: cp, last: last, faded: false }"></ng-container>
                  </div>
                </div>
              </ng-container>

              <!-- SHARED PATROL — grouped by shift window -->
              <ng-container *ngIf="isLocationShared">

              <!-- BEFORE YOUR SHIFT -->
              <div *ngIf="beforeShiftCheckpoints.length > 0" class="shift-section mb-3 shift-patrol-accordion">
                <ngb-accordion #beforeAcc="ngbAccordion" class="custom-accordion" activeIds="before-shift-panel">
                  <ngb-panel id="before-shift-panel">
                    <ng-template ngbPanelTitle>
                      <div class="shift-section-header before-shift w-100 mb-0">
                        <i class="la la-clock-o me-1"></i>
                        BEFORE YOUR SHIFT (Before {{ shiftStartFormatted }})
                        <span class="ms-auto shift-patrol collaps-icon"></span>
                      </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div class="patrol-timeline pt-3">
                        <div *ngFor="let cp of beforeShiftCheckpoints; let last = last">
                          <ng-container *ngTemplateOutlet="checkpointItem; context: { cp: cp, last: last, faded: true }"></ng-container>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>

              <!-- YOUR SHIFT WINDOW -->
              <div *ngIf="duringShiftCheckpoints.length > 0" class="shift-section mb-3 shift-patrol-accordion">
                <ngb-accordion #duringAcc="ngbAccordion" class="custom-accordion" activeIds="during-shift-panel">
                  <ngb-panel id="during-shift-panel">
                    <ng-template ngbPanelTitle>
                      <div class="shift-section-header during-shift w-100 mb-0">
                        <i class="la la-check-circle me-1"></i>
                        YOUR SHIFT WINDOW ({{ shiftStartFormatted }} — {{ shiftEndFormatted || 'Ongoing' }})
                        <span class="ms-auto shift-patrol collaps-icon"></span>
                      </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div class="patrol-timeline pt-3">
                        <div *ngFor="let cp of duringShiftCheckpoints; let last = last">
                          <ng-container *ngTemplateOutlet="checkpointItem; context: { cp: cp, last: last, faded: false }"></ng-container>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>

              <!-- AFTER YOUR SHIFT -->
              <div *ngIf="showAfterShift" class="shift-section mb-3 shift-patrol-accordion">
                <ngb-accordion #afterAcc="ngbAccordion" class="custom-accordion" activeIds="after-shift-panel">
                  <ngb-panel id="after-shift-panel">
                    <ng-template ngbPanelTitle>
                      <div class="shift-section-header after-shift w-100 mb-0">
                        <i class="la la-clock-o me-1"></i>
                        AFTER YOUR SHIFT (After {{ shiftEndFormatted }})
                        <span class="ms-auto shift-patrol collaps-icon"></span>
                      </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div class="patrol-timeline pt-3">
                        <div *ngFor="let cp of afterShiftCheckpoints; let last = last">
                          <ng-container *ngTemplateOutlet="checkpointItem; context: { cp: cp, last: last, faded: true }"></ng-container>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion>
              </div>

              </ng-container>

            </div>
          </div>

          <div class="col-md-5 d-flex flex-column align-items-center shift-patrol-chart-col">
            <div class="shift-patrol-chart-wrapper">
              <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                [plotOptions]="chartOptions.plotOptions" [labels]="chartOptions.labels"
                [fill]="chartOptions.fill"></apx-chart>
            </div>

            <div class="text-center w-100 flex-shrink-0">
              <h4 class="fw-bolder mb-1" [style.color]="gaugeColor">
                {{ patrolDetail?.employee_completion_percentage }}% Completed
              </h4>
              <h6 class="text-muted mb-2">
                We are considering On Time scan
              </h6>
              <button type="button" class="btn btn-primary btn-elevate w-100 px-5"
                (click)="makeScanClickHandler()">
                Scan
              </button>
            </div>
          </div>
        </div>
      </div>
    </kt-loader>
    <div class="modal-footer justify-content-end">
      <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close(hasScanned ? { reload: true } : null)">
      </kt-button>
    </div>
  </div>
</kt-base-modal>